import type { Dispatch, SetStateAction } from 'react'
import type { OverlayLayoutColors } from 'atoms/OverlayLayout'
import type { CARDS_ASPECT_RATIO } from 'blocks/Cards'
import type { CORNERS, SHADOW } from 'vars/index'

export const PlaylistPopoverMenuItems = {
  Default: 'default',
  Seasons: 'seasons',
  Episodes: 'episodes',
} as const
export type PlaylistPopoverMenuItems =
  (typeof PlaylistPopoverMenuItems)[keyof typeof PlaylistPopoverMenuItems]

export interface IEpisode {
  id?: number
  name?: string
  sortOrder?: number
  displayNumber?: string
  landscapeImageUrl?: string
  length?: string
  duration?: number | null
  stoppedTime?: number
  watched?: boolean
  labelPrice?: string
  rented?: boolean
  free?: boolean
  paid?: boolean
  title?: string
  blockedByAcl?: boolean
}
export interface ISeason {
  id?: number
  name?: string
  title?: string
  sortOrder?: number
  displayNumber?: string
  landscapeImageUrl?: string
  episodes: IEpisode[]
  episodesAmount?: number
  labelPrice?: string
  rented?: boolean
  free?: boolean
  paid?: boolean
  blockedByAcl?: boolean
}

export interface IPlaylist {
  episodes?: IEpisode[]
  seasonsWithEpisodes?: ISeason[]
  loading?: boolean
  error?: string
  playEpisode?: (data: { seasonId?: number; episodeId: number }) => void
  currentEpisode?: number | null
}

export interface IPlaylistProps {
  playlist?: IPlaylist
  title?: string
  isLoading?: boolean
  onClose?: () => void
  toggleClassName?: string
  shadow?: SHADOW
  corners?: CORNERS
  posterWidth?: string
  posterAspectRatio?: (typeof CARDS_ASPECT_RATIO)[keyof typeof CARDS_ASPECT_RATIO]
  posterGradient?: OverlayLayoutColors
  aclBlockedTitle?: string
}

export interface IPlaylistPopoverControls {
  setActiveTab: Dispatch<SetStateAction<PlaylistPopoverMenuItems>>
  setActiveSeason: Dispatch<SetStateAction<ISeason | undefined>>
  setActiveEpisode: Dispatch<SetStateAction<IEpisode | undefined>>
  setIsTopNotReached: Dispatch<SetStateAction<boolean>>
  setIsBottomNotReached: Dispatch<SetStateAction<boolean>>
  activeSeason?: ISeason
  activeTab: PlaylistPopoverMenuItems
  isSeasons: boolean
  playlist?: IPlaylist
  onClose?: () => void
}
